<template>
  <div class="productSelection">
    <div class="meter-title">设计选型需求</div>
    <el-form size="small" :model="dataForm">
      <el-form-item label="产品类型:">
        <el-cascader
          placeholder="请选择"
          v-model="dataForm.categoryIds"
          filterable
          collapse-tags
          size="small"
          popper-class="meter-casacader"
          clearable
          :show-all-levels="false"
          :options="categoryTree"
          :props="{
            multiple: true,
            emitPath: false,
            label: 'categoryName',
            value: 'categoryId',
            children: 'children',
          }"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="状态：">
        <el-select
          v-model="dataForm.statusList"
          filterable
          clearable
          multiple
          collapse-tags
          reserve-keyword
          placeholder="请选择"
        >
          <el-option
            v-for="attr in inquiryStatusList"
            :key="attr.value"
            :value="attr.value"
            :label="attr.label"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间：">
        <el-date-picker
          v-model="dataForm.time"
          type="daterange"
          align="right"
          size="small"
          clearable
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="shortcuts"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="getDataList()"
          >查询</el-button
        >
        <el-button size="small" @click="reset()">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="table-diy" v-loading="dataLoading">
      <div class="table-header" :style="{ 'margin-right': barWidth + 'px' }">
        <div>基本配置</div>
        <div>备注</div>
        <div>状态</div>
        <div>创建时间</div>
        <div>操作</div>
      </div>
      <div class="table-body-wrapper">
        <div class="table-body">
          <div class="table-row" v-for="(item, index) in dataList" :key="index">
            <div class="table-info">
              <div>需求单号：{{ item.demandNo || "-" }}</div>
              <div>客户名称：{{ item.companyName || "-" }}</div>
              <div>用户名称：{{ item.createUserName || "-" }}</div>
              <div v-if="item.status === 5">
                未受理原因：<Tooltips :innerContent="item.handleRemark" />
              </div>
            </div>
            <div class="table-content">
              <!-- 基本配置 -->
              <div>
                <div class="one-line">
                  {{ item.categoryLevelTitle1 }}:
                  <Tooltips :innerContent="item.categoryName1" />
                </div>
                <div class="one-line">
                  {{ item.categoryLevelTitle2 }}:
                  <Tooltips :innerContent="item.categoryName2" />
                </div>
                <div class="one-line">
                  {{ item.categoryLevelTitle3 }}:
                  <Tooltips :innerContent="item.categoryName3" />
                </div>
              </div>
              <!-- 备注 -->
              <Tooltips :innerContent="item.userRemark || '-'" />
              <!-- 状态 -->
              <div :style="{ color: getStatusColor(item.status) }">
                {{ item.statusStr || "-" }}
              </div>
              <!-- 创建时间 -->
              <div>{{ item.createTime || "-" }}</div>
              <!-- 操作 -->
              <div>
                <el-button
                  type="text"
                  size="small"
                  style="color: #999"
                  @click="onReject(item)"
                  v-if="item.status === 0"
                  >取消</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  style="color: #2a54d1"
                  @click="toDetail(item)"
                  >{{ item.status === 2 ? "去确认" : "详情" }}</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  style="color: #2fb871"
                  @click="toDownload(item)"
                  v-if="[0, 1, 2, 3].includes(item.status)"
                  >下载</el-button
                >
              </div>
            </div>
          </div>

          <div
            class="no_show_message"
            style="margin: 140px auto"
            v-if="dataList.length === 0"
          >
            <img src="@/assets/img/good/noGood.png" alt="暂无数据" />
            <div>暂无数据</div>
          </div>
        </div>
      </div>
    </div>
    <el-pagination
      style="margin-top: 10px"
      :current-page="dataForm.page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="dataForm.limit"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="pageSizeChangeHandle"
      @current-change="pageCurrentChangeHandle"
    >
    </el-pagination>
  </div>
</template>
<script>
import { shortcuts } from '@/utils/shortcuts'
import exportFun from './export.js'
import Tooltips from '@/components/tooltipShow'
import { formateDate } from '@/utils/formateDate'

const Base64 = require('js-base64').Base64

export default {
  name: 'meterSelection', // 询价列表页
  components: {
    Tooltips
  },
  data () {
    return {
      shortcuts: { shortcuts },
      dataLoading: false,
      inquiryStatusList: [
        { value: '0', label: '待受理', color: '#8D8D19' },
        { value: '1', label: '设计中', color: '#26B2F2' },
        { value: '2', label: '待确认', color: '#F7AD53' },
        { value: '3', label: '已确认', color: '#85C02D' },
        { value: '4', label: '已拒绝', color: '#DE1E3A' },
        { value: '5', label: '未受理', color: '#909090' },
        { value: '6', label: '已取消', color: '#909090' }
      ],
      dataForm: {
        page: 1,
        limit: 10,
        time: null,
        statusList: [],
        categoryIds: []
      },
      total: 0,
      dataList: [],
      barWidth: 0, // 是否有滚动条
      categoryTree: [] // 类目树
    }
  },
  created () {
    this.getTree()
    this.getDataList()
  },
  methods: {
    toDetail (data) {
      window.open(
        `${
          window.location.origin
        }/personalCenter/meterSelectionDetail?demandId=${Base64.encode(
          data.demandId
        )}`
      )
    },
    // 取消的二次提醒
    onReject (row) {
      this.$confirm('请再次确认是否取消您的需求，取消后不可恢复。', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'comfirm-box',
        type: 'warning'
      }).then(() => {
        this.dataLoading = true
        this.$http
          .post(
            `/front/cross/commodity-user/design/demand/cancel?demandId=${row.demandId}`
          )
          .then(({ data: { code } }) => {
            if (code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              this.getDataList()
            } else {
              this.dataLoading = false
            }
          })
          .catch(() => {
            this.dataLoading = false
          })
      })
    },
    // 下载
    toDownload (row) {
      this.dataLoading = true
      exportFun({
        url: `/front/cross/commodity-user/design/demand/exportResult?demandId=${row.demandId}`,
        name: `${row.demandNo}_需求详细信息_${formateDate(
          'yyyyMMddhhmmss',
          new Date()
        )}.xlsx`,
        haveMsg: true
      }).then((t) => {
        // 操作成功
        this.dataLoading = false
        if (t) {
          this.$message.success(this.$t('message.downloadSuccess'))
        }
      })
    },
    // 重置
    reset () {
      this.dataForm.time = null
      this.dataForm.statusList = []
      this.dataForm.categoryIds = []
      this.getDataList()
    },
    // 更改分页条数
    pageSizeChangeHandle (val) {
      this.dataForm.page = 1
      this.dataForm.limit = val
      this.getDataList()
    },
    // 当前页
    pageCurrentChangeHandle (val) {
      this.dataForm.page = val
      this.getDataList()
    },
    // 获取列表数据
    getDataList () {
      const [createTimeStart, createTimeEnd] = this.dataForm.time || []
      const obj = {
        page: this.dataForm.page,
        limit: this.dataForm.limit,
        createTimeStart: createTimeStart ? createTimeStart + ' 00:00:00' : null,
        createTimeEnd: createTimeEnd ? createTimeEnd + ' 23:59:59' : null,
        statusList: this.dataForm.statusList,
        categoryIds: this.dataForm.categoryIds
      }
      this.dataLoading = true
      this.$http
        .post(`/front/cross/commodity-user/design/demand/list`, obj)
        .then(({ data: { code, data } }) => {
          if (code === 0) {
            this.dataList = data.dataList || []
            this.total = +data.count
          }
        })
        .finally(() => {
          this.getScrollbarWidth()
          this.dataLoading = false
        })
    },
    getStatusColor (val) {
      if (!val && val !== 0) {
        return '-'
      }
      const item = this.inquiryStatusList.find((i) => {
        return i.value === val + ''
      })
      if (!item.color) {
        return ''
      } else {
        return item.color
      }
    },
    // 获取容器的滚动条长度
    getScrollbarWidth () {
      this.$nextTick(() => {
        const element = document.querySelector(
          '.table-diy .table-body-wrapper'
        )
        this.barWidth = element.offsetWidth - element.clientWidth
      })
    },
    // 获取类目树
    getTree () {
      this.$http
        .get('/front/cross/commodity-user/design/category/tree')
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.categoryTree = res.data || []
          }
        })
    }
  }
}
</script>

<style lang="scss">
.meter-casacader {
  .el-cascader-panel {
    .el-cascader-menu {
      &:nth-child(1),
      &:nth-child(2) {
        .el-checkbox {
          display: none;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.productSelection {
  .meter-title {
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    margin-bottom: 22px;
  }

  /deep/ .el-cascader {
    .el-cascader__tags {
      .el-tag {
        max-width: calc(50% - 20px) !important;
      }
    }
    .el-cascader__tags {
      input {
        margin-left: 10px;
        min-width: 30px;
        height: 22px;
      }
    }
  }

  .el-form {
    display: flex;

    .el-form-item {
      display: flex;
      white-space: nowrap;
      width: 33%;
      padding-right: 10px;

      &:last-child {
        flex: 1;
        padding-left: 6px;
      }
    }

    .el-date-editor {
      width: 100%;

      /deep/ .el-range-separator {
        padding: 0;
        width: auto;
      }
    }

    .el-button {
      border: none;
      height: 32px;
      border-radius: 16px;
      padding: 9px 24px;

      &.el-button--primary {
        background: linear-gradient(290deg, #2a54d1 -3%, #5b85ff 100%);
      }

      &.el-button--default {
        color: #333;
        background: #f7f8fd;
      }
    }
  }
}

.table-diy {
  .table-header,
  .table-body-wrapper .table-body .table-row .table-content {
    display: flex;
    justify-content: space-between;
    align-items: center;

    > div {
      overflow: hidden;
      text-align: center;
      padding: 0 8px;

      &:nth-child(1) {
        flex: 180;
        text-align: left;
      }

      &:nth-child(2) {
        flex: 130;
      }

      &:nth-child(3) {
        flex: 120;
      }

      &:nth-child(4) {
        flex: 120;
      }

      &:nth-child(5) {
        flex: 120;
      }
    }
  }

  .table-header {
    border: 1px solid rgba(42, 84, 209, 0.4);
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    color: #2a54d1;
    padding: 10px 0 10px 24px;
  }

  .table-body-wrapper {
    height: 499px;
    overflow-x: hidden;
    overflow-y: auto;

    .table-body {
      .table-row {
        margin-top: 10px;
        border: 1px solid rgba(42, 84, 209, 0.2);
        border-radius: 8px;

        .table-info {
          padding: 8px 16px;
          background: rgba(42, 84, 209, 0.05);
          display: flex;
          color: rgba(0, 0, 0, 0.6);

          > div {
            flex: 1;
            overflow: hidden;
            display: flex;
            white-space: nowrap;
          }
        }

        .table-content {
          padding: 16px 0 16px 24px;
          color: #3d3d3d;

          .one-line {
            display: flex;
            white-space: nowrap;
            font-size: 14px;
            font-weight: 500;
            margin-bottom: 12px;

            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
}
</style>
